import { render, staticRenderFns } from "./BaggageListApp.vue?vue&type=template&id=72aa9493&scoped=true"
import script from "./BaggageListApp.vue?vue&type=script&lang=js"
export * from "./BaggageListApp.vue?vue&type=script&lang=js"
import style0 from "./BaggageListApp.vue?vue&type=style&index=0&id=72aa9493&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aa9493",
  null
  
)

export default component.exports